<template>
    <div>
        <el-dialog title="新增" :visible.sync="adddialog" :close-on-click-modal="false">
            <el-form :model="form">
                <el-form-item label="商品分类" :label-width="formLabelWidth">
                        <el-select v-model="form.categoryUuid" clearable placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="广告图上传" :label-width="formLabelWidth">
                    <!-- <el-input v-model="form.img" autocomplete="off"></el-input> -->
                    <el-upload
                        action="/service-center/upload/file/single"
                        list-type="picture-card"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :headers="headers"
                    >
                        <div v-if="!dialogImageUrl">
                            <i class="el-icon-plus"></i>
                        </div>
                        <div>
                            <el-image
                                v-if="dialogImageUrl"
                                :src="dialogImageUrl"
                            >
                            </el-image>
                        </div>
                    </el-upload>
                    <p>请上传长1200px,宽300的图片</p>
                </el-form-item>
                <el-form-item label="链接" :label-width="formLabelWidth">
                    <el-input v-model="linkUrl" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button type="primary" @click="save">保 存</el-button>
                <el-button @click="adddialog = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getShopCategoryList, saveRecommendCategory, modifyRecommendCategory} from "../../../../utils/interface";

    export default {
    data(){
        return{
            headers: {
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
            },
             dialogImageUrl: '',
             dialogVisible: false,
            linkUrl:'',
            adddialog:false,
            formLabelWidth:"100px",
            form:{
            },
             options: [],
            fileList:[],
        }
    },
    created(){
        this.getCategoryList();
    },
    methods:{
          init(type,uuid) {
            this.adddialog = true;
            this.dialogImageUrl = '';
            this.linkUrl = '';
        },
        save(){
            if (!this.form.categoryUuid) {
                this.$alert("请选择商品分类", "提示", {
                    confirmButtonText: "确定",
                });
            }
            this.options.some((item, index) => {
                if(item.value == this.form.categoryUuid){
                    this.form.categoryName = item.label;
                    return true;
                }
            });
            let files = [];
            for (let i = 0; i < this.fileList.length; i++) {
                if(this.linkUrl != '' && this.linkUrl != null){
                    let reg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
//                    配出正确的url
                    let hre = this.linkUrl.match(reg);
                    if (hre == null) {
                        this.$alert('链接地址不正确!', "提示", {
                            confirmButtonText: "确定",
                        })
                        return false;
                    }
                    files.push({
                        path: this.fileList[i].url,
                        linkUrl: this.linkUrl
                    });
                }else{
                    files.push({
                        path: this.fileList[i].url,
                    });
                }
            }
            this.form.fileList = files;
            saveRecommendCategory(this.form).then((response) => {
                if(response.success){
                    this.$message({
                        type: "success",
                        message: "保存成功",
                    });
                    this.adddialog = false;
                    this.$parent.search();
                }else{
                    this.$message({
                        type: "error",
                        message: response.message,
                    });
                }

            });
        },
        getCategoryList(){
            let params = {
                parentUuid:"",
                grade:"1",
                type:'PLATFORM',
                current:1,
                pageSize:1000,
            }
            getShopCategoryList(params).then((res)=>{
                this.options = [];
                if (res != null && res.list != null && res.list.length > 0) {
                    res.list.forEach((item, index) => {
                        this.options.push({value:item.uuid,label:item.name});
                    });
                }
            });
        },
      //   // 删除文件提示按钮
      //   beforeRemove(file, fileList) {
      //       return this.$confirm(`确定移除 ${file.name}？`);
      //   },
      //   //上传图片方法
      //    handleRemove(file, fileList) {
      //       console.log(file, fileList);
      //        this.fileList = fileList;
      // },
      // handlePictureCardPreview(file) {
      //     this.dialogImageUrl = file.url;
      //     this.dialogVisible = true;
      // },
        handleAvatarSuccess(obj, fileList) {
            console.log(obj);
            this.fileList = [];
            this.dialogImageUrl = obj.url;
            this.fileList.push(obj);
        },
        beforeAvatarUpload(file) {
            this.dialogVisible = true
            const isJPG = file.type.indexOf('image') !== -1;
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.warning('上传图片只能是图片格式!');
                this.dialogVisible = false
            }
            if (!isLt2M) {
                this.$message.warning('上传图片大小不能超过 2MB!');
                this.dialogVisible = false
            }
            return isJPG && isLt2M;
        },
    }
}
</script>

<style scoped lang="less">
    /deep/.el-input__inner{
        width: 300px;
    }
    /deep/.el-upload-list__item-status-label{
        display: none !important;
    }
    /deep/ .el-icon-zoom-in:before {
        display: none;
    }
    /deep/ .el-icon-delete:before{
        margin-left: -14px;
    }

</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/category/dialog/addDialog.vue